import React from 'react';

export const ContentContext = React.createContext();
export const ModalContext = React.createContext();